import React, { useState } from 'react';
import {
  Form,
  Button,
  Alert,
  Container,
  Row,
  Col,
  InputGroup,
} from 'react-bootstrap';
import http from '../services/http';
import { getUser } from '../services/auth';

export default function CreateUser() {
  const me = getUser();
  const isDev = me?.role === 'dev';

  const [form, setForm] = useState({
    username: '',
    password: '',
    role: 'view',   // por defecto view
    enabled: true,
  });
  const [msg, setMsg] = useState('');
  const [variant, setVariant] = useState('success');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setMsg('');
    setLoading(true);
    try {
      await http.post('/users', form);
      setVariant('success');
      setMsg('Usuario creado correctamente.');
      setForm({ username: '', password: '', role: 'view', enabled: true });
    } catch (err) {
      setVariant('danger');
      setMsg(err?.response?.data?.error || 'Error creando usuario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5" style={{ maxWidth: 600 }}>
      <h3 className="mb-3">Crear usuario</h3>
      <Form onSubmit={onSubmit}>
        <Row className="g-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Usuario</Form.Label>
              <Form.Control
                name="username"
                value={form.username}
                onChange={onChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={6}>
          <Form.Group>
            <Form.Label>Contraseña</Form.Label>
            <div className="input-password-wrapper">
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={form.password}
                onChange={onChange}
                required
                minLength={4}
              />
              <i
                className={`toggle-eye bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}
                onClick={() => setShowPassword(v => !v)}
              ></i>
            </div>
          </Form.Group>
          </Col>
        </Row>

        <Row className="g-3 mt-0">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Rol</Form.Label>
              <Form.Select
                name="role"
                value={form.role}
                onChange={onChange}
              >
                {/* ADMIN solo puede crear admin o view */}
                {!isDev && (
                  <>
                    <option value="admin">admin</option>
                    <option value="view">view</option>
                  </>
                )}

                {/* DEV también puede crear dev */}
                {isDev && (
                  <>
                    <option value="dev">dev</option>
                    <option value="admin">admin</option>
                    <option value="view">view</option>
                  </>
                )}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={6} className="d-flex align-items-center">
            <Form.Check
              type="checkbox"
              label="Habilitado"
              name="enabled"
              checked={form.enabled}
              onChange={onChange}
            />
          </Col>
        </Row>

        <div className="mt-3 d-flex gap-2">
          <Button type="submit" disabled={loading}>
            {loading ? 'Guardando…' : 'Crear'}
          </Button>
        </div>
      </Form>

      {msg && <Alert className="mt-3" variant={variant}>{msg}</Alert>}
    </Container>
  );
}


